import { Box, ProgressBar, Card, Text } from '@nimbus-ds/components';
import useNuvemEnvioTranslations from 'domains/NuvemEnvioCommons/hooks/useNuvemEnvioTranslations/useNuvemEnvioTranslations';
import LabelProgressTitle from './components/LabelProgressTitle';
import { ProgressCardType } from '../../../constants';

interface ProgressCardProps {
  progressPercentage: number;
  totalOrders?: number;
  generatedOrders?: number;
  type?: ProgressCardType;
}

function ProgressCard({
  progressPercentage,
  totalOrders,
  generatedOrders,
  type,
}: Readonly<ProgressCardProps>) {
  const t = useNuvemEnvioTranslations();

  return (
    <Box id="ProgressCard">
      <Card>
        <Card.Header>
          <Box display="flex" alignItems="center">
            <LabelProgressTitle
              title={
                type === ProgressCardType.SEARCH
                  ? t(
                      'printNuvemEnvioLabelsStatus.asyncPage.progressCard.title',
                    )
                  : t(
                      'printNuvemEnvioLabelsStatus.asyncPage.progressCard.titleSimulation',
                    )
              }
            />
            {typeof totalOrders === 'number' &&
              totalOrders > 1 &&
              type !== ProgressCardType.BILLING_SIMULATION && (
                <Box ml="auto">
                  <Text>
                    {generatedOrders} de {totalOrders}
                  </Text>
                </Box>
              )}
          </Box>
        </Card.Header>
        <Card.Body>
          <ProgressBar appearance="primary" value={progressPercentage} />
        </Card.Body>
      </Card>
    </Box>
  );
}

export default ProgressCard;
